
import Decimal from "decimal.js";
import { globalDexieDb } from "../db/DexiedbLib";
import { IContact } from "../db/model/contact";
import { ApiResult, ContactExtraInfo } from "../db/report/localBackend";
import store from "../store";
import { boolean } from "mathjs";

export function debounce(func: Function, delay: number): any {
    let timer: ReturnType<typeof setTimeout>; // lần goij sau, biến timer này có giá trị, chứ ko phải undefined như bt
    let i: number = 0;
    return function (...args: any[]): any {
        clearTimeout(timer);
        // if (DEBUG)
        //     console.log(`clearTimeout(${timer})`)
        timer = setTimeout(() => func.apply(this, args), delay);
        // if (DEBUG)
        //     console.log(`new timer(${timer})`)
    };
}
export function isCuPhapMienBac(): boolean {
    let ret = false;
    const mienCuPhapId = Number(localStorage["mienCuPhapId"])
    ret = mienCuPhapId == 1
    return ret;
}
export function GetMienCuPhapID(): number {
    let ret = Number(localStorage["mienCuPhapId"])
    if (isNaN(ret))
        ret = 2; //mien nam
    return ret;
}
export function GetUserID(): string {
    let ret = Number(localStorage["userId"])
    if (isNaN(ret))
        ret = 0;
    return ret + "";
}
export function hasRightGetTestMessage(): boolean {

    const userFullInfo = GetUserFullInfo()
    if (userFullInfo.username == "admin" || userFullInfo.username == "hoangsg" ||
        "gamelade" == userFullInfo.username  ||"tong01" == userFullInfo.username 
    ) {
        return true
    }
    return false;
}
export function isLocalMode(): boolean {
    let ret = Number(localStorage["localMode"])
    if (isNaN(ret))
        ret = 0;
    return ret == 1;
}
export function GetTinhId(): string {
    let tinhId: string = localStorage["tinhId"]
    return tinhId
}
export function GetDayOfWeek(d: string): number {
    const date: Date = new Date(d)
    return date.getDay();
}
export function GetCurMien(): string {
    const mienId = store.getState().basicReport.mienDaiCuocId
    let mien = "NAM"
    switch (Number(mienId)) {
        case 1:
            mien = "BAC"
            break;
        case 2:
            mien = "TRUNG"
            break;
    }
    return mien;
}
export function removeVietnameseAccent(str: string) {
    // Chuyển các ký tự có dấu thành không dấu
    var withAccent = "àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸĐ";
    var withoutAccent = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeiiiiiooooooooooooooooouuuuuuuuuuuyyyyydAAAAAAAAAAAAAAAAAEEEEEEEEEEEIIIIIOOOOOOOOOOOOOOOOOUUUUUUUUUUUYYYYYD";

    // Thay thế các ký tự có dấu bằng ký tự không dấu
    for (var i = 0; i < withAccent.length; i++) {
        var charWithAccent = withAccent.charAt(i);
        var charWithoutAccent = withoutAccent.charAt(i);
        var regex = new RegExp(charWithAccent, 'g');
        str = str.replace(regex, charWithoutAccent);
    }

    return str;
}
export async function getSmsKhopTin(result: ApiResult, curMien: string): Promise<Map<string, string>> {
    let ret: Map<string, string> = new Map()
    if (result.data) {
        let data: ContactExtraInfo[] = result.data as ContactExtraInfo[]
        for (let inf of data) {
            let sms = ''
            const contact: IContact | undefined = await globalDexieDb.contacts.where('contactId').equals(inf.contactId).first()
            let ngoi1 = 'cty'
            let ngoi2 = 'Khách'
            let chatId = 0
            if (contact) {
                ngoi2 = contact.ngoi2!
                chatId = contact.tlUserId!
            } else {
                return ret;
            }
            if (curMien == 'NAM') {
                if (inf.mnCountIn > 0) {
                    sms = `MN ${ngoi2} chuyển cho ${ngoi1} ${inf.mnCountIn} tin`
                }
                if (inf.mnCountOut > 0) {
                    const tmp = `MN ${ngoi1} chuyển cho ${ngoi2} ${inf.mnCountOut} tin`
                    sms += sms == '' ? tmp : `\n${tmp}`
                }
            } else if (curMien == 'TRUNG') {
                if (inf.mtCountIn > 0) {
                    sms = `MT ${ngoi2} chuyển cho ${ngoi1} ${inf.mtCountIn} tin`
                }
                if (inf.mtCountOut > 0) {
                    const tmp = `MT ${ngoi1} chuyển cho ${ngoi2} ${inf.mtCountOut} tin`
                    sms += sms == '' ? tmp : `\n${tmp}`
                }
            } else if (curMien == 'BAC') {
                const mien = isCuPhapMb() ? '' : 'MB'
                if (inf.mbCountIn > 0) {
                    sms = `${mien} ${ngoi2} chuyển cho ${ngoi1} ${inf.mbCountIn} tin`
                }
                if (inf.mbCountOut > 0) {
                    const tmp = `${mien} ${ngoi1} chuyển cho ${ngoi2} ${inf.mbCountOut} tin`
                    sms += sms == '' ? tmp : `\n${tmp}`
                }
            }
            if (sms != '') {
                ret.set(`${chatId}`, sms)
            }
        }
    }

    return ret;
}
export const isCuPhapMb = () => isCuPhapMienBac()
export const isCuPhapMn = () => !isCuPhapMienBac()
export function GetUserFullInfo(): any {
    const str = localStorage['userFullInfo']
    if (str == undefined || str == null) {
        const userObject = {
            parentUserId: 0,
            userId: 0,
            username: "",
            userGroupRole: "",
            pathToUser: "",
            password: "",
            expDate: "0001-01-01T00:00:00Z",
            isLocked: 0,
            mienCuPhapId: 0,
            tinhId: "",
            rptTemplete: 0,
            ghiChu: "",
            hanMuc: 0,
            localMode: 0,
            dbName: "",
            loginLimit: 0,
            suDungTinAndroid: 0,
            suDungTinBot: 0,
            sapXepTin: 2,
        };
        return userObject

    } else {
        return JSON.parse(str)
    }
}
export function IsBetToolEnable() {
    const userId = localStorage['userId']
    return userId == 142 || userId == 370 || userId == 55 || userId == 449 || userId == 454
}
export function Remove2C3C4C(loaiCuocId: string): string {
    const ret = loaiCuocId
        .replace(/2C$/, "").replace(/3C$/, "").replace(/4C$/, "")
        .replace(".", "")
    // .replace(/\.2C$/, "").replace(/\.3C$/, "").replace(/\.4C$/, "")
    // .replace(/\XXX$/, "").replace(/\XXX$/, "").replace(/\XXX$/, "")

    return ret;
}
export function GetLineFromGia(gia: number): number {
    const giaX100 = new Decimal(gia).mul(100)
    const lai = new Decimal(100).sub(giaX100) //bignumber((100 - gia * 100))
    const result = Number(lai.toString())
    console.log(`GetLineFromGia lai=${result} , gia = ${gia}`)
    return result
}
export function ValidTextChuyen(str: string): boolean {
    const regex = /^[1-9][0-9]*\s*%?$/;
    return regex.test(str);
}
export function ReplaceMultipleSpaces(str: string): string {
    return str.replace(/\s+/g, ' ');
}